import React, { ReactElement } from 'react';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import { FrontPageState } from '../../../reducer';
import { toDateString } from '../../../../utils';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/autoplay';
import 'swiper/scss/pagination';
import TopBlockErrorBoundary from './TopBlockErrorBoundary';

export default function SxkArticlesBlock(): ReactElement {
  const { articles, isLoading } = useSelector((state: FrontPageState) => ({
    articles: state.articles,
    isLoading: state.isLoading.indexOf('articles') !== -1,
  }));
  return (
    <TopBlockErrorBoundary
      name="SxkArticlesBlock"
      title="Nyheter från Svenska Kryssarklubben"
      message="Misslyckades ladda nyheter från Svenska Kryssarklubben"
    >
      <div id="intro-articles" className="intro-segment section-part-third news-feed">
        <div className="media-feed-title page-title-box">
          <div className="media-feed-title-wrap page-title-box-inner content-bg">
            <div className="member-feed-header">
              <div className="member-feed-title">
                <h3 className="feed-title">
                  <span className="aligner-middle" />
                  <span className="media-feed-title-part">Nyheter från Svenska Kryssarklubben</span>
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div id="sxk-articles-slideshow" className="section-content">
          {isLoading && (
            <div className="media-feed-loader">
              <div className="cssload-container">
                <ul className="cssload-flex-container">
                  <li>
                    <span className="cssload-loading" />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {!isLoading && (
            <Swiper
              modules={[Navigation, A11y, Autoplay, Pagination]}
              autoplay={{
                delay: 10_000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              pagination
              loop
              slidesPerView={1}
            >
              {articles.items.slice(0, 5).map((item) => (
                <SwiperSlide key={item.id}>
                  <div
                    className="article-slide-image"
                    style={{
                      backgroundImage: `url('${item.image}')`,
                    }}
                  />
                  <div className="article-slide-content">
                    <div className="article-slide-title-container">
                      <h3 className="article-slide-title">
                        <a href={item.link} tabIndex={-1}>
                          {item.label}
                        </a>
                      </h3>
                    </div>
                    <div className="article-slide-created">{toDateString(item.timestamp)}</div>
                    <div className="article-slide-text">{item.ingress}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
        <div className="article-slide-link">
          <a className="btn btn-default btn-feed" href="/artiklar">
            Tidigare artiklar
          </a>
        </div>
      </div>
    </TopBlockErrorBoundary>
  );
}
